import apiHelpers from './apiHelpers.js';
import { mapCrudStoreGen } from '@/helpers/utils/storeHelpers.js';

let defaultForm = {
  name: '',
  brandId: '',
  integrationSystem: 'LoopReturns',
  integrationGroup: 'OrderReturnsSystem',
  integrationStatus: 'Active',
  apiKey: ''
};

let defaultFilters = {
  brandId: null,
  integrationSystem: null,
  integrationGroup: null,
  integrationStatus: null
};

let genedStore = mapCrudStoreGen(defaultForm, defaultFilters, apiHelpers);

export default {
  namespaced: true,

  state: () => ({
    ...genedStore.state
  }),

  mutations: {
    ...genedStore.mutations
  },

  getters: {
    ...genedStore.getters
  },

  actions: {
    ...genedStore.actions
  }
};
